import {createAction} from "redux-actions";
import {makeActionType} from "../utils";
import {resetError, setError} from "./errors";
import request from './utils/request';
import {urls} from "../constants/app";

const namespace = 'REASON';


export const setReasons = createAction(makeActionType(namespace, ['SET']));
export const deleteReasonSuccess = createAction(makeActionType(namespace, ['DELETE', 'REASON']));


export function fetchWriteOffFormReasons(withoutLoader = false, force = false) {
    return async (dispatch, getState) => {
        const { reasons } = getState();

        if (!force && reasons.items && reasons.items.length > 0) {
            return;
        }

        !withoutLoader && dispatch({ type: 'SET_LOADER', field: 'reasons', value: true });
        dispatch(resetError('reasons'));
        try {
            const reasons = await request({ method: 'get', url: urls.writeoffreasons });
            dispatch(setReasons(reasons));
        } catch (error) {
            dispatch(setError(error, 'reasons'));
        } finally {
            dispatch({ type: 'SET_LOADER', field: 'reasons', value: false });
        }
    };
}

export function deleteWriteOffReason(id) {
    return async (dispatch) => {
        dispatch({ type: 'SET LOADER', field: 'writeOffs', value: true });
        try {
            await request({ method: 'delete', url: `${urls.writeoffreasons}/${id}` })
            dispatch(deleteReasonSuccess(id));
        } catch (error) {
            dispatch(setError(error, 'writeOffs'));
        }
    }
}

export function updateWriteOffReason(id, reasonData) {
    return async (dispatch) => {
        dispatch({ type: 'SET LOADER', field: 'writeOffs', value: true });
        try {
            await request({ method: 'put', url: `${urls.writeoffreasons}/${id}`, data: reasonData });
            dispatch(fetchWriteOffFormReasons());
            dispatch({ type: 'SET LOADER', field: 'writeOffs', value: false });
        } catch (error) {
            dispatch(setError(error, 'writeOffs'));
            dispatch({ type: 'SET LOADER', field: 'writeOffs', value: false });
        }
    }
}

export function addWriteOffReason(reasonData) {
    return async (dispatch) => {
        dispatch({ type: 'SET LOADER', field: 'writeOffs', value: true });
        try {
            await request({ method: 'post', url: urls.writeoffreasons, data: reasonData });
            dispatch({ type: 'SET LOADER', field: 'writeOffs', value: false });
        } catch (error) {
            dispatch(setError(error, 'writeOffs'));
            dispatch({ type: 'SET LOADER', field: 'writeOffs', value: false });
        }
    };
}